import { Controller } from '@hotwired/stimulus'
import { Turbo } from '@hotwired/turbo-rails'
import { enter, leave } from 'el-transition'
import { CommandPaletteController } from './command_palette_controller'
// import { useHotkeys } from 'stimulus-use/hotkeys'

export default class extends Controller {
  static outlets = ['command-palette']

  static targets = ['navbar', 'sidebar', 'background', 'panel', 'overlay']

  declare readonly commandPaletteOutlet: CommandPaletteController
  declare readonly sidebarTarget: HTMLDivElement
  declare readonly backgroundTarget: HTMLDivElement
  declare readonly panelTarget: HTMLDivElement
  declare readonly overlayTarget: HTMLDivElement

  connect(): void {
    // TODO: implement this once the new weigh in form is ready
    // useHotkeys(this, {
    //   w: [this.navigateToWeighIn],
    // })
  }

  toggleSidebar(): void {
    if (this.sidebarTarget.classList.contains('hidden')) {
      this.sidebarTarget.classList.remove('hidden')
      enter(this.backgroundTarget)
      enter(this.panelTarget)
      enter(this.overlayTarget)
    } else {
      Promise.all([
        leave(this.backgroundTarget),
        leave(this.panelTarget),
        leave(this.overlayTarget),
      ]).then(() => {
        this.sidebarTarget.classList.add('hidden')
      })
    }
  }

  toggleCommandPalette(event: MouseEvent): void {
    event.preventDefault()
    event.stopPropagation()
    this.commandPaletteOutlet.openValue = !this.commandPaletteOutlet.openValue
  }

  private navigateToWeighIn = (event: KeyboardEvent): void => {
    Turbo.visit('/weigh-in', { frame: 'modal' })
  }
}
